//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The api headers enum
*
* 
*  * RESULTS_TOTAL value: x-total-results - The total count of paginated results 
*  * CLIENT_ID value: x-client-id - The current client id 
*  * API_VERSION value: x-api-version - The current used api version 
*/
@Serializable
enum class Headers(val value: kotlin.String) {

    @SerialName(value = "x-total-results")
    RESULTS_TOTAL("x-total-results"),

    @SerialName(value = "x-client-id")
    CLIENT_ID("x-client-id"),

    @SerialName(value = "x-api-version")
    API_VERSION("x-api-version");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is Headers) "$data" else null

    /**
    * Returns a valid [Headers] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): Headers? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

